export const firebaseConfig = {
    apiKey: "AIzaSyANAv2jZUw9Ha194IsKCKSMTM7uH0eccgU",
    authDomain: "markcadavero.firebaseapp.com",
    projectId: "markcadavero",
    storageBucket: "markcadavero.appspot.com",
    messagingSenderId: "1084387909135",
    appId: "1:1084387909135:web:5dde94c17abdc3d3e70d7a",
    measurementId: "G-THJ3R2LYJE"
};
